<template>
    <div>
        <!-- VIEW -->
        <v-container>
            <v-row class="ma-0">
                <v-col>
                <p class="headline text-center">Monitoring Kontrak</p>
                </v-col>
            </v-row>
            <v-row class="mx-2">
                <v-col cols="6">
                <v-select
                    :items="objItemsDivisi"
                    label="Filter Divisi"
                    v-model="divisiSel"
                    single-line
                    hide-details
                    clearable
                    @change="divisiSelChange"
                ></v-select>
                </v-col>       
            </v-row>
            <v-row class="ma-0">
                <v-col cols="12">
                    <v-data-table
                            class="elevation-1"
                            :headers="table.headers"
                            :items="table.items"
                            :items-per-page="10"
                            :single-select="true"
                            :search="search"
                            item-key="id"
                            no-data-text="Belum ada data !"
                            height="400"
                            fixed-header>
                            
                            <template v-slot:item.divisi="{item}">
                                {{ getDivisi(item.divisi) }}
                            </template>
                            <template v-slot:item.tglKontrak="{item}">
                                {{ getDateFormattedDatefns(item.tglKontrak, "dd MMM yyyy") }}
                            </template>
                            <template v-slot:item.mulaiKontrak="{item}">
                                {{ getDateFormattedDatefns(item.mulaiKontrak, "dd MMM yyyy") }}
                            </template>
                            <template v-slot:item.selesaiKontrak="{item}">
                                {{ getDateFormattedDatefns(item.selesaiKontrak, "dd MMM yyyy") }}
                            </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    const axios = require("axios").default;
    const apiUrl = process.env.VUE_APP_ROOT_API;
    import { format, parseISO } from 'date-fns';
    import { getValueItem } from "./../../lib/viewLib";

    export default {
        data() {
            return {
                filter: "all",
                objItemsDivisi: [],
                divisiSel: "",
                search: "",
                table:
                {
                    headers: 
                    [
                        { text: "Nama Paket", value:"nama"},
                        { text: "Divisi", value:"divisi"},
                        { text: "No. SPK", value:"noSpk"},
                        { text: "Tgl.Kontrak", value:"tglKontrak"},
                        { text: "Tgl.Mulai", value:"mulaiKontrak"},
                        { text: "Tgl.Selesai", value:"selesaiKontrak"},
                        { text: "Hari", value:"hari"},
                        { text: "Pembuat", value:"userId"},
                    ],
                    items: []
                },
            }
        },
        created() {
            this.getDataDivisi()
            this.getData()
        },
        methods:{
            getDivisi(divisi) { 
            return getValueItem(this.objItemsDivisi, divisi)
            },
            getDataDivisi() {
                axios.get(`${apiUrl}/monitor2/masterdivisi`)
                .then((response) => {
                    let dataDivisi = response.data.data;
                    this.objItemsDivisi = new Array;
                    this.objItemsDivisi.push({
                        text: "Semua",
                        value: "all",
                        parent: "all",
                        nick: "all"
                    })

                    dataDivisi.forEach(el => {
                        this.objItemsDivisi.push({
                            text: el.nama,
                            value: el.kode,
                            parent: el.parent,
                            nick: el.nick
                        })
                    })
                })
                .catch((error) => {
                    console.error(error);
                });
            },
            getData(divisi='all') {
                axios.get(`${apiUrl}/monitor2/monitor-kontrak/${divisi}`)
                .then((response) => {
                    this.table.items = response.data.data;
                })
                .catch((error) => {
                    console.error(error);
                });
            },
            divisiSelChange() {
                this.getData(this.divisiSel);
            },
            getDateFormattedDatefns: function(date, form = "dd MMM yyyy") {
                return date ? format(parseISO(date), form) : ''
            },
        }
    }

</script>

            
<style scoped>

    .container{
        max-width: 100vw;
        padding:0px;
    }

</style>